<!--
 * @Author: cryi.liu
 * @Date: 2020-04-30 11:12:18
 * @LastEditTime: 2020-05-26 14:15:00
 * @Description: 用户信息
 -->
<template>
  <div v-if="userName" class="user-info">
    <span>用户名称：{{ userName }}</span>
  </div>
</template>

<script>
export default {
  name: 'UserInfo',
  data() {
    return {
      userName: '',
    };
  },
  created() {
    this.userName = localStorage.getItem('userName');
  },
};
</script>

<style lang="less" scoped>
.user-info {
  display: inline-block;
  padding-right: 12px;
  color: #fff;
}
</style>
